import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-container">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Logotipo_del_Gobierno_de_Espa%C3%B1a.svg/1280px-Logotipo_del_Gobierno_de_Espa%C3%B1a.svg.png" alt="Spanish Flag" className="spanish-flag-icon" />
              <div className="logo">Cita Facil</div>
            </div>
            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <a href="#home" onClick={closeMenu}>Inicio</a>
              <a href="#about" onClick={closeMenu}>Acerca de</a>
              <a href="#services" onClick={closeMenu}>Servicios</a>
              <a href="#how-it-works" onClick={closeMenu}>Cómo Funciona</a>
              <a href="#reviews" onClick={closeMenu}>Reseñas</a>
              <a href="#contact" onClick={closeMenu}>Contacto</a>
            </nav>
            <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
